export function stickyMainVariables() {
    const prevArrowHtml = '<button class="slick-btn slick-btn--prev" aria-label="Previous" type="button"><div class="slick-btn__icon-blk"><i class="fa-solid fa-chevron-left"></i></div></button>';
    const nextArrowHtml = '<button class="slick-btn slick-btn--next" aria-label="Next" type="button"><div class="slick-btn__icon-blk"><i class="fa-solid fa-chevron-right"></i></div></button>';
    const arrowsContainer = '.l-slick__area--arrows';
    const dotsContainer = '.l-slick__area--dots';
    const delayBetweenSlides = 3000;
    const animationSpeed = 600;

    return { prevArrowHtml, nextArrowHtml, arrowsContainer, dotsContainer, delayBetweenSlides, animationSpeed }
}

//export const stickyV = {
//    prevArrowHtml: '<button class="slick-btn slick-btn--prev" aria-label="Previous" type="button"><div class="slick-btn__icon-blk"><i class="fa-solid fa-chevron-left"></i></div></button>',
//    nextArrowHtml: '<button class="slick-btn slick-btn--next" aria-label="Next" type="button"><div class="slick-btn__icon-blk"><i class="fa-solid fa-chevron-right"></i></div></button>',
//    arrowsContainer: '.l-slick__area--arrows',
//    dotsContainer: '.l-slick__area--dots',
//    delayBetweenSlides: 3000,
//    animationSpeed: 600,
//}